import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios"
import { useUser } from "../UserContext";
import { useHistory } from "react-router-dom";
const ReportWeeklyIndustryContext = createContext();

export const ReportWeeklyIndustryProvider = ({ children }) => {
    const { industry, jogo } = useUser()

    const [reportWeeklyIndustry, setReportWeeklyIndustry] = useState({
        purchases: [],
        pcp: [],
        productions: [],
        salesInProgress: [],
        salesDone: []
    })
    const [loading, setLoading] = useState(false)

    const fetchReportWeeklyIndustry = useCallback(async () => {
        if (!industry?.industria || !jogo?.jogo) return
        try {
            setLoading(true)
            const { data: allRounds } = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/rodada/listarRodadas/${jogo?.jogo}`)

            /*
                Fluxo Produção
            */
            const promisesProductions = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/producao/listarRodada/${industry?.industria}/${round?.rodada}`)
            })

            const productionsData = await Promise.all(promisesProductions)
            const productions = productionsData.map(item => item.data).filter(item => item.length > 0)
            let filteredProductionsData = []

            for (let i = 0; i < productions.length; i++) {
                let newProductionsData = productions[i].reduce((acc, item) => {
                    if (acc.length === 0) {
                        acc.push({
                            ...item,
                            produtoProd: [{
                                produto: { ...item.produto },
                                quantidadeTotalProduzir: item.quantidadeProduzir,
                                custoTotalProd: item.custoTotal
                            }]
                        })
                        return acc
                    }
                    const itemIndex = acc?.findIndex(acumulatorItem => acumulatorItem?.produto?.produto === item?.produto?.produto)

                    if (itemIndex >= 0) {
                        acc[itemIndex].produtoProd[0].quantidadeTotalProduzir = acc[itemIndex].produtoProd[0].quantidadeTotalProduzir += item.quantidadeProduzir
                        acc[itemIndex].produtoProd[0].custoTotalProd = acc[itemIndex].produtoProd[0].custoTotalProd += item.custoTotal
                        return acc
                    }

                    acc.push({
                        ...item,
                        produtoProd: [{
                            produto: { ...item.produto },
                            quantidadeTotalProduzir: item.quantidadeProduzir,
                            custoTotalProd: item.custoTotal
                        }]
                    })
                    return acc

                }, [])

                filteredProductionsData.push(newProductionsData)
            }

            /*
                Fim Fluxo Produção
            */

            /*
                Fluxo Purchase
            */
            const promisesPurchases = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/compra/listar/${industry?.industria}/${round?.rodada}`)
            })
            const purchaseData = await Promise.all(promisesPurchases)
            const purchase = purchaseData.map(item => item.data).filter(item => item.length > 0)
            let filteredPurchaseData = []
            for (let i = 0; i < purchase.length; i++) {
                let newPurchaseData = purchase[i].reduce((acc, item) => {
                    if (acc.length === 0) {
                        acc.push({
                            ...item,
                            insumoCompras: [{
                                ...item.insumo,
                                quantidadeTotal: item.quantidade
                            }]
                        })
                        return acc
                    }
                    const itemIndex = acc?.findIndex(acumulatorItem => acumulatorItem?.insumo?.insumo === item?.insumo?.insumo)
                    if (itemIndex >= 0) {
                        const insumoIndex = acc[itemIndex].insumoCompras.findIndex(sameInsumo => sameInsumo?.insumo === item?.insumo?.insumo)
                        acc[itemIndex].insumoCompras[insumoIndex].quantidadeTotal = acc[itemIndex].insumoCompras[insumoIndex].quantidadeTotal += item.quantidade
                        return acc
                    }

                    acc.push({
                        ...item,
                        insumoCompras: [{
                            ...item.insumo,
                            quantidadeTotal: item.quantidade
                        }]
                    })
                    return acc

                }, [])

                filteredPurchaseData.push(newPurchaseData)
            }
            /*
              Fim Fluxo Purchase
           */


            /*
             Fluxo PCP
            */
            const promisesPCP = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/listar/${industry?.industria}/${round?.rodada}`)
            })
            const pcpData = await Promise.all(promisesPCP)
            const pcp = pcpData.map(item => item.data).filter(item => item.length > 0)
            /*
             Fim Fluxo PCP
            */

            /* Fluxo vendas*/
            const promisessalesInProgess = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/venda/listarIndustria/${industry?.industria}/${round.rodada}/A`)
            })

            const salesInProgessData = await Promise.all(promisessalesInProgess)
            const salesInProgess = salesInProgessData.map(item => item.data).filter(item => item.length > 0)

            let filteredsalesInProgessData = []

            for (let i = 0; i < salesInProgess.length; i++) {
                let newsalesInProgessData = salesInProgess[i].reduce((acc, item) => {
                    if (acc?.length === 0) {
                        acc.push({
                            ...item,
                            vendaProd: [{
                                produto: {
                                    ...item.itens[0].produto
                                },
                                quantidadeTotal: item.itens[0].quantidade,
                                valorTotal: item.itens[0].total
                            }]
                        })
                        return acc
                    }

                    const itemIndex = acc?.findIndex(acumulatorItem => acumulatorItem?.itens[0]?.produto?.produto === item?.itens[0]?.produto?.produto)
                    if (itemIndex >= 0) {
                        acc[itemIndex].vendaProd[0].quantidadeTotal = acc[itemIndex].vendaProd[0].quantidadeTotal += item.itens[0].quantidade
                        acc[itemIndex].vendaProd[0].valorTotal = acc[itemIndex].vendaProd[0].valorTotal += item.itens[0].total
                        return acc
                    }

                    acc.push({
                        ...item,
                        vendaProd: [{
                            ...item.itens[0],
                            quantidadeTotal: item.itens[0].quantidade,
                            valorTotal: item.itens[0].total
                        }]
                    })
                    return acc

                }, [])

                filteredsalesInProgessData.push(newsalesInProgessData)
            }

            const promisessalesDone = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/venda/listarIndustria/${industry?.industria}/${round.rodada}/E`)
            })

            const salesDoneData = await Promise.all(promisessalesDone)
            const salesDone = salesDoneData.map(item => item.data).filter(item => item.length > 0)

            let filteredsalesDoneData = []

            for (let i = 0; i < salesDone.length; i++) {
                let newsalesDoneData = salesDone[i].reduce((acc, item) => {
                    if (acc?.length === 0) {
                        acc.push({
                            ...item,
                            vendaProd: [{
                                produto: {
                                    ...item.itens[0].produto
                                },
                                quantidadeTotal: item.itens[0].quantidade,
                                valorTotal: item.itens[0].total
                            }]
                        })
                        return acc
                    }

                    const itemIndex = acc?.findIndex(acumulatorItem => acumulatorItem?.itens[0]?.produto?.produto === item?.itens[0]?.produto?.produto)
                    if (itemIndex >= 0) {
                        acc[itemIndex].vendaProd[0].quantidadeTotal = acc[itemIndex].vendaProd[0].quantidadeTotal += item.itens[0].quantidade
                        acc[itemIndex].vendaProd[0].valorTotal = acc[itemIndex].vendaProd[0].valorTotal += item.itens[0].total
                        return acc
                    }

                    acc.push({
                        ...item,
                        vendaProd: [{
                            ...item.itens[0],
                            quantidadeTotal: item.itens[0].quantidade,
                            valorTotal: item.itens[0].total
                        }]
                    })
                    return acc

                }, [])

                filteredsalesDoneData.push(newsalesDoneData)
            }

            /* Fim fluxo compras */

            setReportWeeklyIndustry({
                purchases: filteredPurchaseData,
                pcp,
                productions: filteredProductionsData ?? [],
                salesInProgress: filteredsalesInProgessData ?? [],
                salesDone: filteredsalesDoneData ?? []
            })
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }

    }, [industry, jogo])

    return (
        <ReportWeeklyIndustryContext.Provider
            value={{
                reportWeeklyIndustry,
                loading,
                fetchReportWeeklyIndustry,
                setReportWeeklyIndustry
            }}
        >
            {children}
        </ReportWeeklyIndustryContext.Provider>
    );
};

export const useReportWeeklyIndustry = () => useContext(ReportWeeklyIndustryContext);
